
import { defineComponent, reactive } from 'vue';
import { useRouter, Router } from 'vue-router';
import ManagementFrame from '@/components/ui/managementFrame/index.vue';
import SvgIcon from '@/components/SvgIcon.vue';
import '@/assets/icons/back.svg';
import backToTeacherHome from '@/lib/backToTeacherHome';
import CustomCaseController, { CustomCase } from '@/views/Teacher/customCase/js/customCaseModule';
import { Pagination } from 'ant-design-vue';
import Modal from '@/components/Modal.vue';

export default defineComponent({
  name: 'custom-case-list',
  components: {
    ManagementFrame,
    SvgIcon,
    aPagination: Pagination,
    aModal: Modal,
  },
  methods: {
    backToTeacherHome: (r: Router) => backToTeacherHome(r),
  },
  setup() {
    const router = useRouter();
    const customCase = reactive(new CustomCase());
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const customCaseController = new CustomCaseController(customCase as any, router);

    return {
      customCase,
      customCaseController,
    };
  },
});
